module.exports = __webpack_public_path__ + "img/icon_map_53_off_101.3538088d.png";